
class ProductListHelper{
    //获取产品列表搜索器的category分类的ids
    static getCategoryIds(path,categoriesIds) {
        let commonUtils = require('@/utils/common_utils');
        let keys1 = [];
        let id_category = path.substring(path.lastIndexOf('/') + 1);
        if (!this.isNumber(id_category)){
            keys1 = categoriesIds;
            return keys1;
        }
        if (id_category.length===6) id_category = id_category.substr(0,4);
        let value = commonUtils.getObjValue(categoriesIds, id_category,'object');
        if (id_category.length === 2) {
            keys1[id_category] = value;
        } else if (id_category.length === 4) {
            keys1[id_category.substr(0, 2)] = {};
            keys1[id_category.substr(0, 2)][id_category.substr(0, 4)] = value;
        } else if (id_category.length === 6) {
            keys1[id_category.substr(0, 2)] = {};
            keys1[id_category.substr(0, 2)][id_category.substr(0, 4)] = {};
            keys1[id_category.substr(0, 2)][id_category.substr(0, 4)][id_category.substr(0, 6)] = value;
        }
        return keys1;
    }

    //获取图片url,需要判断是否显示,
    static getProdImgUrl(mea_month_delay,product,imgUrl,vue){
        let isShowRealImg = this.isShowProdImgForVisitor(mea_month_delay,product,vue);
        //未登录且该产品的创建时间超过了商家设置的最近能查看的时间点就显示错误图片。
        if (!isShowRealImg){
            return require(`@/assets/img/productList/visitor_default_prod.jpg`)
        }
        return product.url;
    }

    //是否显示给游客产品图片数据
    static isShowProdImgForVisitor(mea_month_delay,product,vue){
        if (vue.$store.state.token) return true;
        let sea_month_delay= mea_month_delay;
        let isShowRealImg = true;
        if (sea_month_delay){
            let beforeMonth = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000 * sea_month_delay));
            let ctime = new Date(product.dateCreation);
            //预定时间点之前的产品都能查看
            isShowRealImg = ctime.getTime() < beforeMonth.getTime();
        }
        return isShowRealImg;
    }

    static isNumber(val) {
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if(regPos.test(val) || regNeg.test(val)) {
            return true;
        } else {
            return false;
        }
    }

    //通过分类id,获取他的libelle名字
    static getCategoryName(id_category,vue) {
        try {
            id_category += '';
            let name = '';
            if (!id_category) return ' ';
            let categories = vue.$store.state.categories;
            if (Object.keys(categories).includes(id_category)
                || id_category.length === 2) {
                name = categories[id_category].categories_langues[0].libelle;
            } else if (id_category.length === 4) {
                name = categories[id_category.substring(0, 2)].subcategories[id_category].categories_langues[0].libelle;
            } else if (id_category.length === 6) {
                name = categories[id_category.substring(0, 2)]
                    .subcategories[id_category.substring(0, 4)]
                    .subcategories[id_category]
                    .categories_langues[0].libelle;
            }
            return name;
        } catch (e) {
            return ' ';
        }
    }
}
module.exports = ProductListHelper;
